import { Inmate } from '@reliance/types/models/Inmate';
import React, { useCallback, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useAlerts } from '../../alert/AlertContext';
import api from '../../common/api';

type InmateOperationsProps = {
  inmate: Inmate;
  onSuccess?: () => void;
};

const InmateOperations: React.FC<InmateOperationsProps> = (props) => {
  const { inmate, onSuccess } = props;
  const alerts = useAlerts();
  const [clearingFaceSignature, setClearingFaceSignature] = useState(false);

  const handleClearFaceSignature = useCallback(async () => {
    if (!inmate?.id) {
      return;
    }
    setClearingFaceSignature(true);
    try {
      await api.delete(`/inmate/${inmate.id}/face/signature`);
      alerts.success('Face signature will be cleared on the device shortly', true);
      onSuccess?.();
    } catch {
      alerts.error('An error occurred when clearing the face signature', true);
    } finally {
      setClearingFaceSignature(false);
    }
  }, [inmate?.id, onSuccess]);

  return (
    <div className="row">
      <div className="col-md-12">
        <Button
          variant="secondary"
          className="me-2"
          disabled={clearingFaceSignature}
          onClick={handleClearFaceSignature}>
          {clearingFaceSignature ? (
            <>
              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
              Clearing...
            </>
          ) : (
            'Clear Face Signature'
          )}
        </Button>
      </div>
    </div>
  );
};

export default InmateOperations;
